import React, { useRef, useState } from "react";
import { Box, Button, Grid, Modal, Typography,CircularProgress } from "@mui/material";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import "../../components/style.scss";
import "./UploadPopup.scss";
import Upload from "../../components/Upload";
import uploadCloudBlueImg from "../../assets/icons/upload-cloud-blue.png";
import cameraImg from "../../assets/icons/camera.png";
import fileTextImg from "../../assets/icons/file-text.png";
import deleteIcon from "../../assets/icons/delete-red.svg";
import CropIcon from "@mui/icons-material/Crop";

import CropImage from "./CropImage";
import WebCamera from "./WebCamera";
import { checkFileSize } from "../../utilis/common-funtions";
import {
  ALLOWED_FILE_FORMATS,
  GST_FILE_SIZE_MB,
  MAX_FILE_SIZE_MB,
  PDF_FILE_SIZE_MB,
  ALLOWED_PDF_FILE_FORMATS,
  ALLOWED_ONLY_PDF_FILE,
  UPLOAD_TYPE
} from "../../config/constant";
import SnackbarAlert from "../snackbar-alert/SnackbarAlert";
import {
  deleteImage,
} from "../../pages/customer-form/customer-form.slice";
import { compressAndUploadFile } from "../../pages/customer-form/compressionUpload";
import { isNotImageFile } from "../../utilis/uploadUtils";
const { REACT_APP_S3_BASE_URL } = process.env;

function UploadPopup({
  heading,
  totalImages,
  closePopup,
  handleImageValue,
  uploadedImage,
  fieldName,
  handleUpdateImageData,
  handlePhysicalImage,
  selectedOptionValue,
  isGSTUpload,
  fileType,
  voucherMutliUpload = false,
  disabled=false,
  hidePhysicalCopyOption = false,
  hideCameraOption = false,
  dynamicSize='',
  showDeleteIcon = true,
  documentName,
  documentNumber,
}) {
  const dispatch = useDispatch();
  const { oppId, voucherId } = useParams();
  const opportunityId = oppId || voucherId;
  const [openModal, setOpenModal] = useState(true);
  const [selectedOption, setSelectedOption] = useState(
    selectedOptionValue === true ? "physical" : "files"
  );
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [uploadedFiles, setUploadedFiles] = useState(uploadedImage);
  const [showCropImage, setShowCropImage] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showWebCameraImage, setShowWebCameraImage] = useState(true);
  const [snackbarConfig, setSnackBarconfig] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const croppedImageRef = useRef();
  const [rotate, setRotate] = useState(0); // state in parent



  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    validation(files, e);
    e.target.value = null;
  };

  const handleFileChangeWebCamera = (file) => {
    const files = Array.from([file]);
    setShowWebCameraImage(false);
    validation(files);
  };

  const handleCropImage = () => {
    setShowCropImage(true);
  };

  const validation = (files, event) => {
    // Determine allowed file formats based on field type
    const allowedFormats =
      fileType === UPLOAD_TYPE.PDF_IMAGE ? ALLOWED_PDF_FILE_FORMATS: fileType === UPLOAD_TYPE.PDF ? ALLOWED_ONLY_PDF_FILE : ALLOWED_FILE_FORMATS;

    files.forEach((file) => {
      const isNonImage = isNotImageFile(file);
      let maxSize;
      let errorMessage;

      if (isGSTUpload) {
        maxSize = GST_FILE_SIZE_MB;
        errorMessage = `File size must be less than ${maxSize}MB: ${file.name}`;
      }
      else if (dynamicSize) {
        maxSize = dynamicSize;
        errorMessage = `File size must be less than ${maxSize}MB: ${file.name}`;
      }
      else if (isNonImage) {
        maxSize = PDF_FILE_SIZE_MB;
        errorMessage = `PDF file size must be less than ${maxSize}MB: ${file.name}`;
      } else {
        maxSize = MAX_FILE_SIZE_MB;
        errorMessage = `Image file size must be less than ${maxSize}MB: ${file.name}`;
      }

      if (!checkFileSize(file, maxSize)) {
        setSnackBarconfig({
          open: true,
          message: fileType === UPLOAD_TYPE.PDF_IMAGE
            ? `Invalid file format. Please upload a PDF (max ${dynamicSize ? dynamicSize : PDF_FILE_SIZE_MB}MB) or JPEG (max ${dynamicSize ? dynamicSize : MAX_FILE_SIZE_MB}MB) file.`
            : errorMessage,
          severity: "error",
        });
      } else if (!allowedFormats.includes(file.type)) {
        setSnackBarconfig({
          open: true,
          message: fileType ===UPLOAD_TYPE.PDF_IMAGE
            ? `Invalid file format. Please upload a PDF (max ${dynamicSize ? dynamicSize : PDF_FILE_SIZE_MB}MB) or JPEG (max ${dynamicSize ? dynamicSize : MAX_FILE_SIZE_MB}MB) file.`
            : "Unsupported file format: " + file.name,
          severity: "error",
        });
      } else {
        setSelectedFiles((prevFiles) => [file]);

        // Automatically open crop interface for image files
        if (!isNonImage) {
          setShowCropImage(true);
        }
      }
    });
  };

  const handleSnackbarClose = () => {
    setSnackBarconfig({
      open: false,
      message: "",
      severity: "",
    });
  };
  const handleCroppedImageReady = (file) => {
    croppedImageRef.current = file;
  };
  const handleUploadImages = async () => {
  const file = croppedImageRef.current || selectedFiles[0];
  if (!file) return;

  if (file.type === "application/pdf") {
    const buffer = await file.slice(0, 5).arrayBuffer();
    const header = new TextDecoder().decode(buffer);
    if (!header.startsWith("%PDF-")) {
      setSnackBarconfig({
        open: true,
        message: "The uploaded file is not a valid or readable PDF.",
        severity: "error",
      });
      return;
    }
  }

  setLoading(true);

    const presignedUrlPayload = {
      folder: `images/${opportunityId}`,
      key: file?.name.replace(/\s+/g, ""),
    };
    try {
      const result = await dispatch(compressAndUploadFile({
        file,
        presignedUrlPayload,
        fieldName,
      })).unwrap();

      if (result?.uploadResult?.status === 200) {
        setLoading(false);
        const imageKey = result?.presignedResponse?.data?.key;
        handleImageValue(fieldName, [imageKey]);
        closePopup(false);
        if (result?.successMessage) {
          setSnackBarconfig({
            open: true,
            message: result.successMessage,
            severity: "success",
          });
        }
      }
    } catch (error) {
      setLoading(false);
      console.error('Upload failed:', error);
      setSnackBarconfig({
        open: true,
        message: error || 'Upload failed. Please try again.',
        severity: "error",
      });
    }
  };

  const handleUploadPhysical = (value) => {
    if(!hidePhysicalCopyOption){
      handlePhysicalImage(fieldName, value);
    }
    closePopup(false);
  };

  const handleDeleteImage = () => {
    if (selectedFiles.length > 0) {
      setSelectedFiles([]);
      setShowCropImage(false);
      setShowWebCameraImage(true);
    } else {
      let payload = {
        key: uploadedFiles[0],
      };
      dispatch(deleteImage(payload))
        .unwrap()
        .then((res) => {
          if (res?.success) {
            setUploadedFiles([]);
            handleUpdateImageData(fieldName, []);
          }
        });
    }
  };
  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const files = Array.from(e.dataTransfer.files);
    validation(files, e);
  };
  return (
    <div>
      <Modal
        open={openModal}
        onClose={() => {
          setOpenModal(!openModal);
        }}
        hideBackdrop={true}
        disableEscapeKeyDown={true}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="UploadDetailsModal"
      >
        <Box
          className="modalContainer"
          sx={{
            width: { xs: "90%", sm: "80%", md: "70%", lg: "50%" },
            maxHeight: "80vh",
            overflowY: "auto",
            bgcolor: "background.paper",
            boxShadow: 24,
            borderRadius: 1,
            p: 4,
          }}
        >
          <Box sx={{ border: "0" }}>
            <div className="closeModal" onClick={() => closePopup(false)}>
              <HighlightOffIcon />
            </div>
            <Typography
              className="modalTitle"
              id="modal-modal-title"
              variant="h6"
              component="h2"
            >
              {uploadedFiles?.length > 0 ? "Preview" : heading}
            </Typography>
            {documentName && documentNumber && (
              <Box sx={{ mb: 1}}>
                {documentName && (
                  <Typography
                    component="span"
                    sx={{ fontSize: "14px", fontWeight: "400" }}
                  >
                    {documentName}: &nbsp;
                  </Typography>
                )}
                {documentNumber && (
                  <Typography
                  component="span"
                  sx={{ fontSize: "14px", fontWeight: "600" }}
                  >
                    {documentNumber}
                  </Typography>
                )}
              </Box>
            )}  
            {uploadedFiles?.length === 0 ? (
              <Typography
                className="titlePra"
                sx={{ fontWeight: "bold", textAlign: "center" }}
              >
                Please select how you'd like to submit your document.
              </Typography>
            ) : null}
            {uploadedFiles?.length === 0 ? (
              <div className="uploadTags">
                <Grid container spacing={3}>
                  <Grid
                    item
                    xs={12}
                    sm={hidePhysicalCopyOption && !hideCameraOption ?6 : hidePhysicalCopyOption && hideCameraOption ? 12 :4}
                    md={hidePhysicalCopyOption && !hideCameraOption ?6 : hidePhysicalCopyOption && hideCameraOption ? 12 :4}
                    lg={hidePhysicalCopyOption && !hideCameraOption ?6 : hidePhysicalCopyOption && hideCameraOption ? 12 :4}
                    xl={hidePhysicalCopyOption && !hideCameraOption ?6 : hidePhysicalCopyOption && hideCameraOption ? 12 :4}
                    className="boxCheckInputContainer"
                  >
                    <div
                      className={`checkBox ${selectedOption === "files" && `selectedCheckBox`
                        }`}
                      onClick={() => {
                        setSelectedOption("files");
                        if (!voucherMutliUpload && !hidePhysicalCopyOption) {
                          handlePhysicalImage(fieldName, false);
                        }
                        setSelectedFiles([]);
                      }}
                    >
                      <div>
                        <span className="flexIcon">
                          <img
                            src={uploadCloudBlueImg}
                            alt=""
                            style={{ height: "20px", width: "20px" }}
                          />
                          Upload from files
                        </span>
                      </div>
                    </div>
                  </Grid>
                  {!hideCameraOption && <Grid
                    item
                    xs={12}
                    sm={hidePhysicalCopyOption ?6 :4}
                    md={hidePhysicalCopyOption ?6 :4}
                    lg={hidePhysicalCopyOption ?6 :4}
                    xl={hidePhysicalCopyOption ?6 :4}
                    className="boxCheckInputContainer"
                  >
                    <div
                      className={`checkBox ${selectedOption === "camera" && `selectedCheckBox`
                        }`}
                      onClick={() => {
                        setSelectedOption("camera");
                        if (!voucherMutliUpload && !hidePhysicalCopyOption) {
                          handlePhysicalImage(fieldName, false);
                        }
                        
                        setSelectedFiles([]);
                      }}
                    >
                      <div>
                        <span className="flexIcon">
                          <img
                            src={cameraImg}
                            alt=""
                            style={{ height: "20px", width: "20px" }}
                          />
                          Capture from camera
                        </span>
                      </div>
                    </div>
                  </Grid>}
                  {!hidePhysicalCopyOption && <Grid
                    item
                    xs={12}
                    sm={4}
                    md={4}
                    lg={4}
                    xl={4}
                    className="boxCheckInputContainer"
                  >
                    <div
                      className={`checkBox ${selectedOption === "physical" && `selectedCheckBox`
                        }`}
                      onClick={() => {
                        setSelectedOption("physical");
                        setSelectedFiles([]);
                      }}
                      
                    >
                      <div>
                        <span className="flexIcon">
                          <img
                            src={fileTextImg}
                            alt=""
                            style={{ height: "20px", width: "20px" }}
                          />
                          Upload Later
                        </span>
                      </div>
                    </div>
                  </Grid>}
                </Grid>
              </div>
            ) : null}

            {selectedOption === "files" && (
              <div
                style={{
                  border: "1px dashed #ddd",
                  padding: "20px",
                  textAlign: "center",
                  cursor: "pointer",
                }}
              >
                {uploadedFiles?.length > 0 && showDeleteIcon && (
                  <div style={{ textAlign: "right" }}>
                    <Button
                      sx={{
                        width: "44px",
                        height: "48px",
                        borderRadius: "8px",
                        background: "#fff",
                        textTransform: "capitalize",
                        border: "1px solid #FDA29B",
                        "&:hover": {
                          backgroundColor: "#FDA29B",
                        },
                        "&:disabled": {
                          border: "none",
                          backgroundColor: "#BDBDBD",
                          opacity: 0.7,
                          cursor: "not-allowed",
                          pointerEvents: "none",
                        },
                      }}
                      onClick={handleDeleteImage}
                      disabled={disabled} 
                    >
                      <img src={deleteIcon} alt="" />
                    </Button>
                  </div>
                )}
                {selectedFiles?.length > 0 && (
                  <div style={{ textAlign: "right", marginBottom: "20px" }}>
                    {showCropImage === false && selectedFiles[0].type !== "application/pdf" && (
                      <Button
                        sx={{
                          width: "72.5px",
                          height: "44px",
                          borderRadius: "8px",
                          textTransform: "capitalize",
                          backgroundColor: "#fff",
                          color: "#092552",
                          marginRight: "16px",
                          border: "1px solid #092552",
                          "&:hover": {
                            backgroundColor: "#092552",
                            color: "#fff",
                          },
                        }}
                        onClick={handleCropImage}
                      >
                        <CropIcon />
                      </Button>
                    )}
                    <Button
                      sx={{
                        width: "44px",
                        height: "48px",
                        borderRadius: "8px",
                        background: "#fff",
                        textTransform: "capitalize",
                        border: "1px solid #FDA29B",

                        "&:hover": {
                          backgroundColor: "#FDA29B",
                        },
                      }}
                      onClick={handleDeleteImage}
                    >
                      <img src={deleteIcon} alt="" />
                    </Button>
                    {selectedFiles.length > 0 && (
                      <Button
                        sx={{
                          width: "100px",
                          height: "48px",
                          // marginRight: "16px",
                          marginLeft: "16px",
                          borderRadius: "8px",
                          background: "#1A407D",
                          color: "#fff",
                          fontSize: "16px",
                          fontWeight: "600",
                          lineHeight: "24px",
                          textTransform: "capitalize",
                          "&:hover": {
                            backgroundColor: "#092552",
                          },
                        }}
                        onClick={handleUploadImages}
                      >
                        {loading ? (
                            <CircularProgress
                              size={24}
                              sx={{ color: "white" }}
                            />
                          ) : (
                            "Save"
                          )}
                      </Button>
                    )}
                  </div>
                )}
                {totalImages === 1 && (
                  <div
                    className="frontSide"
                    onDragOver={handleDragOver}
                    onDrop={handleDrop}
                  >
                    {selectedFiles?.length === 0 &&
                      uploadedFiles?.length === 0 && (
                        <Upload
                          handleFileChange={handleFileChange}
                          path="fileInput"
                          isGSTUpload={true}
                          fileType={fileType}
                          pdf={true}
                          dynamicSize={dynamicSize}
                        />
                      )}
                    {showCropImage && (
                      <>
                        <CropImage
                          selectedFiles={selectedFiles}
                          handleFileChangeWebCamera={handleFileChangeWebCamera}
                          onCroppedImageReady={handleCroppedImageReady}
                          rotate={rotate}
                        />
                        <div
                          style={{ textAlign: "center", marginBottom: "16px" }}
                        >
                          <label>Rotate: {rotate}°</label>
                          <input
                            type="range"
                            min="-180"
                            max="180"
                            step="1"
                            value={rotate}
                            onChange={(e) => setRotate(Number(e.target.value))}
                            style={{ width: "100%" }}
                          />
                        </div>
                      </>
                    )}

                    {(selectedFiles?.length > 0 || uploadedFiles?.length > 0) &&
                      !showCropImage &&
                      (selectedFiles?.[0]?.type === "application/pdf" ||
                        (typeof uploadedFiles?.[0] === "string" &&
                          uploadedFiles[0].toLowerCase().endsWith(".pdf"))) && (
                        <div className="uploadPreview">
                          {selectedFiles?.[0]?.type === "application/pdf" ? (
                            <iframe
                              src={URL.createObjectURL(selectedFiles[0])}
                              width="100%"
                              height="600px"
                              title="PDF Preview"
                            />
                          ) : uploadedFiles?.[0] &&
                            typeof uploadedFiles[0] === "string" &&
                            uploadedFiles[0].toLowerCase().endsWith(".pdf") ? (
                            <iframe
                              src={`${REACT_APP_S3_BASE_URL}/${uploadedFiles[0]}`}
                              width="100%"
                              height="600px"
                              title="PDF Preview"
                            />
                          ) : null}
                        </div>
                      )}
                    {(selectedFiles?.length > 0 || uploadedFiles?.length > 0) &&
                      showCropImage === false &&
                      (!selectedFiles?.[0] ||
                        selectedFiles[0].type !== "application/pdf") &&
                      (!uploadedFiles?.[0] ||
                        !uploadedFiles[0].toLowerCase().endsWith(".pdf")) ? (
                      <div className="uploadImage">
                        <img
                          src={
                            uploadedFiles?.length > 0
                              ? `${REACT_APP_S3_BASE_URL}/${uploadedFiles[0]}`
                              : URL.createObjectURL(selectedFiles[0])
                          }
                          alt="profile-image"
                        />
                      </div>
                    ) : null}
                  </div>
                )}
              </div>
            )}

            {selectedOption === "camera" && (
              <>
                {showWebCameraImage && (
                  <WebCamera
                    handleFileChangeWebCamera={handleFileChangeWebCamera}
                  />
                )}
                {selectedFiles?.length > 0 && (
                  <>
                    <div style={{ textAlign: "right", marginBottom: "16px" }}>
                      {showCropImage === false && (
                        <Button
                          sx={{
                            width: "72.5px",
                            height: "44px",
                            borderRadius: "8px",
                            textTransform: "capitalize",
                            backgroundColor: "#fff",
                            color: "#092552",
                            marginRight: "16px",
                            border: "1px solid #092552",
                            "&:hover": {
                              backgroundColor: "#092552",
                              color: "#fff",
                            },
                          }}
                          onClick={handleCropImage}
                        >
                          <CropIcon />
                        </Button>
                      )}
                      <Button
                        sx={{
                          width: "44px",
                          height: "48px",
                          borderRadius: "8px",
                          background: "#fff",
                          textTransform: "capitalize",
                          border: "1px solid #FDA29B",
                          "&:hover": {
                            backgroundColor: "#FDA29B",
                          },
                        }}
                        onClick={handleDeleteImage}
                      >
                        <img src={deleteIcon} alt="" />
                      </Button>

                      {selectedFiles.length > 0 && (
                        <Button
                          sx={{
                            width: "100px",
                            height: "48px",
                            marginLeft: "16px",
                            borderRadius: "8px",
                            background: "#1A407D",
                            color: "#fff",
                            fontSize: "16px",
                            fontWeight: "600",
                            lineHeight: "24px",
                            textTransform: "capitalize",
                            "&:hover": {
                              backgroundColor: "#092552",
                            },
                          }}
                          onClick={handleUploadImages}
                        >
                           {loading ? (
                            <CircularProgress
                              size={24}
                              sx={{ color: "white" }}
                            />
                          ) : (
                            "Save"
                          )}
                        </Button>
                      )}
                    </div>
                  </>
                )}
                {showCropImage && (
                  <>
                    <CropImage
                      selectedFiles={selectedFiles}
                      handleFileChangeWebCamera={handleFileChangeWebCamera}
                      onCroppedImageReady={handleCroppedImageReady}
                      rotate={rotate}
                    />
                    <div
                      style={{ textAlign: "center", marginBottom: "16px" }}
                    >
                      <label>Rotate: {rotate}°</label>
                      <input
                        type="range"
                        min="-180"
                        max="180"
                        step="1"
                        value={rotate}
                        onChange={(e) => setRotate(Number(e.target.value))}
                        style={{ width: "100%" }}
                      />
                    </div>
                  </>
                )}
                {(selectedFiles?.length > 0 || uploadedFiles?.length > 0) &&
                  showCropImage === false ? (
                  <div className="uploadImage">
                    <img
                      src={
                        uploadedFiles?.length > 0
                          ? `${REACT_APP_S3_BASE_URL}/${uploadedFiles[0]}`
                          : URL.createObjectURL(selectedFiles[0])
                      }
                      alt="profile-image"
                    />
                  </div>
                ) : null}
              </>
            )}
            {selectedOption === "physical" && (
              <>
                {selectedOption === "physical" && (
                  <div style={{ textAlign: "right" }}>
                    <Button
                      sx={{
                        width: "100px",
                        height: "48px",
                        marginRight: "16px",
                        borderRadius: "8px",
                        background: "#1A407D",
                        color: "#fff",
                        fontSize: "16px",
                        fontWeight: "600",
                        lineHeight: "24px",
                        textTransform: "capitalize",
                        "&:hover": {
                          backgroundColor: "#092552",
                        },
                      }}
                      onClick={() => handleUploadPhysical(true)}
                    >
                      Save
                    </Button>
                  </div>
                )}

                <Typography
                  sx={{
                    fontSize: "14px",
                    lineHeight: "22px",
                    fontWeight: "600",
                    color: "#1A407D",
                    textAlign: "center",
                    mt: { xs: 2, sm: 3, md: 4, lg: 5, xl: 6 },
                  }}
                >
                  Please Upload Later with your RM
                </Typography>
              </>
            )}
          </Box>
        </Box>
      </Modal>
      <SnackbarAlert
        open={snackbarConfig.open}
        message={snackbarConfig.message}
        severity={snackbarConfig.severity}
        onClose={handleSnackbarClose}
      />
    </div>
  );
}

export default UploadPopup;
